import React from 'react';
import PropTypes from 'prop-types';
import { constants, ParagraphSecondary } from '@klarna/bubble-ui';

const Badge = ({ text, backgroundColor = constants.Colors.GRAY, white = false }) => {
  const style = {
    display: 'inline-block',
    backgroundColor: backgroundColor,
    borderRadius: '5px',
    alignSelf: 'center',
    padding: '2px 10px',
    marginBottom: '3.5px',
    marginTop: '3.5px',
    marginRight: '7px',
  };

  return (
    <div style={style}>
      <ParagraphSecondary overflowEllipsisWidth white={white}>
        {text}
      </ParagraphSecondary>
    </div>
  );
};

Badge.propTypes = {
  text: PropTypes.string.isRequired,
  backgroundColor: PropTypes.string,
  white: PropTypes.bool,
};

export default Badge;
